import { render } from "./ToolsTab.vue?vue&type=template&id=99920ef2&scoped=true&lang=pug"
import script from "./ToolsTab.js?vue&type=script&lang=js&external"
export * from "./ToolsTab.js?vue&type=script&lang=js&external"

import "./ToolsTab.vue?vue&type=style&index=0&id=99920ef2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99920ef2"]])

export default __exports__